export default __webpack_public_path__ + "static/univote-a785f50c9c0b61bffbec1ea470f0f7cb.jpg";